import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, fontSize } = theme.tokens;
  return {
    page: {
      ...theme.mixins.page,
      gap: 24
    },
    popular: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      marginTop: 16
    },
    title: {
      margin: 0,
      fontSize: fontSize.h2,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h2 }
    },
    grid: {
      width: "calc(100% + 20px)",
      margin: "0 -10px",
      [theme.media.phone]: { width: "calc(100% + 12px)", margin: "0 -6px" }
    }
  };
});

export default withCustomStyles;
